import { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import dashboardApi from 'services/api/dashboard'

import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import connectLeft from '../../img/connect/connect-left.svg'
import connectRight from '../../img/connect/connect-right.svg'

class MagicLink extends Component {
  state = {
    verifyStatus: 'verifying'
  }

  verifyUser = () => {
    const id = this.props.match.params.id
    dashboardApi
      .verifyMagicLink({ token: id })
      .then(() => {
        this.setState({ verifyStatus: 'verified' })
      })
      .catch(() => {
        this.setState({ verifyStatus: 'error' })
      })
  }

  componentDidMount() {
    this.verifyUser()
  }

  render() {
    return (
      <RenderVerifyComponent
        dispatch={this.props.dispatch}
        verifyStatus={this.state.verifyStatus}
      />
    )
  }
}

const RenderVerifyComponent = ({ verifyStatus }) => {
  switch (verifyStatus) {
    case 'verifying':
      return <LoadingIndicator show={true} />
    case 'verified':
      return <LoggedIn />
    case 'error':
      //dispatch(setMagicLinkStatus('error'))
      return <Error />
    case 'expired':
      //dispatch(setMagicLinkStatus('expired'))
      return <Expired />
    default:
      return <div>Default</div>
  }
}

const LoggedIn = () => (
  <div className="magic-link-content">
    <div className="swp-mdl-connectedbar pop">
      <div className="swp-mdl-connected-icon">
        <img src={connectLeft} alt="" className="swp-mdl-connected-icon-left" />
        <img src={connectRight} alt="" className="swp-mdl-connected-icon-right" />
      </div>
      <h1>You are logged in to dashboard!</h1>
      <p>You can close this window.</p>
    </div>
  </div>
)

const Error = () => (
  <div className="magic-link-content">
    <div className="swp-mdl-connectedbar">
      <h1>Something went wrong.</h1>
      <p>Please try again later.</p>
    </div>
  </div>
)

const Expired = () => <Redirect to={'/login/expired'} />

export default connect(null)(MagicLink)
